/* eslint-disable security/detect-object-injection */

export async function UpdateApiValidation(initialDocument, updateDocumentSate) {
    let obj = {}
    Object.keys(initialDocument).forEach((item) => {
        // if(updateDocumentSate[item] !== "") {
        obj = {...obj, [item] : updateDocumentSate[item]}
        // }
    })
    return obj
}